import React from 'react'
import styled from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

interface Props {
  htmlFor?: string
  className?: string

  color?: string
}

export const Label: React.FC<Props> = ({
  htmlFor,
  color,
  children,
  className,
}) => {
  return (
    <Wrapper htmlFor={htmlFor} className={className} color={color}>
      {children}
    </Wrapper>
  )
}

interface WrapperProps {
  color?: string
}

const Wrapper = styled.label<WrapperProps>`
  display: block;
  font-size: 1rem;
  color: ${({ color }) => color || themeEstra.color.primari.grigioEstra};
  margin-bottom: 0.5rem;
`
